import React, { useState, useEffect, useRef } from 'react';
import BASE_URL from "../../../../config/config";
import { useNavigate, useLocation } from 'react-router-dom';
import CustomerStockService from "../../Controller/CustomerStockController";
import CreateCustomerStock from "./CreateCustomerStock";
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import Swal from 'sweetalert2';
import HelpSite from "../../../Common/HelpLink";
import PartSelectionModal from "./PartSelectionModal";
import QuotationService from "../../../Quotation/Controller/QuotationController";
import { handleSubmit } from "../../Controller/CreateCustomerStockController";
function CustomerDocumentPage({ ClientCompanyID }) {
    const navigate = useNavigate();
    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };
    ClientCompanyID = localStorage.getItem('ClientCompanyID');
    const CustomerID = ClientCompanyID;
    const tableRef = useRef();
    const [SupplierList, setSupplierData] = useState([]);
    const [CustomerStockList, setCustomerStock] = useState([]);
    const [modalInstance, setModalInstance] = useState(null);
    const [currentCustomerStock, setCurrentCustomerStock] = useState(null);
    const CompanyID = localStorage.getItem("CompanyID");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const [partList, setPartData] = useState([]);
    const [formData, setFormData] = useState([]);
    const [errors, setErrors] = useState({});
    const [selectedRows, setSelectedRows] = useState([]);
    const initDataTable = () => {
        if ($.fn.DataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }
        $(tableRef.current).DataTable({
            "paging": true,
            "searching": true,
            "info": true,
            order: [[0, 'desc']],
        });
    };
    useEffect(() => {
        if (CustomerStockList.length > 0) {
            initDataTable();
        }
    }, [CustomerStockList]);
    const fetchParts = async () => {
        try {
            const redirectCallback = () => navigate('/');
            const data = await CustomerStockService.GetAllParts(redirectCallback, CustomerID);
            setPartData(data);
        } catch (error) {
            console.error('Error fetching parts:', error);
        }
    };
    const fetchCustomerStock = async () => {
        try {
            $(tableRef.current).DataTable().destroy();
            const data = await CustomerStockService.GetAllCustomerStock(redirectCallback, CustomerID);
            setCustomerStock(data);
        } catch (error) {
            console.error('Error fetching Contacts:', error);
        }
    };

    useEffect(() => {
        if (ClientCompanyID > 0) {
            fetchParts();
            fetchCustomerStock();
        }
    }, [ClientCompanyID]);

    const handleCreateCustomerStockClick = () => {
        setCurrentCustomerStock(null);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const handleEditClick = (document) => {
        setCurrentCustomerStock(document);
        setIsModalOpen(true);
    };
    const handleDeleteClick = async (event, ID) => {
        event.stopPropagation(); // Prevent the row click event

        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await CustomerStockService.DeleteCustomerStock(ID, redirectCallback);
                    $(tableRef.current).DataTable().destroy();
                    fetchCustomerStock(); // Refresh the list after deletion

                    Swal.fire(
                        'Deleted!',
                        'Your record has been deleted.',
                        'success'
                    );
                } catch (error) {
                    console.error('Error deleting job:', error);
                    Swal.fire(
                        'Error!',
                        'There was a problem deleting the record.',
                        'error'
                    );
                }
            }
        });
    };
    const handleSuccess = () => {
        fetchCustomerStock(); // Refresh the list after submission
        handleCloseModal();   // Close the modal
    };
    const handlePartSelect = async (parts) => {

        try {

            for (const item of parts) {

                const payload = {
                    StockID: item.PK_Stock_ID,
                    vc_StockCode: item.vc_StockCode,
                    vc_StockName: item.vc_StockName,
                    mon_SalesPrice: item.mon_SalesPrice,
                    SpecialPrice: item.SpecialPrice,
                    FK_Customer_ID: CustomerID,
                    ID: item.CustomerStockID ?? 0
                };

                await handleSubmit(
                    null,
                    payload,
                    setFormData,
                    setErrors,
                    () => { },
                    () => { }
                );
            }

            //   onSuccess();
            fetchCustomerStock();

        } catch (error) {
            console.error(error);
        }
    };
    const handleMultipleDelete = async () => {

        if (selectedRows.length === 0) {
            Swal.fire(
                'Warning',
                'Please select at least one record.',
                'warning'
            );
            return;
        }

        Swal.fire({
            title: 'Are you sure?',
            text: `Delete ${selectedRows.length} selected record(s)?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete them!'
        }).then(async (result) => {

            if (result.isConfirmed) {

                try {

                    for (const id of selectedRows) {
                        await CustomerStockService.DeleteCustomerStock(
                            id,
                            redirectCallback
                        );
                    }

                    setSelectedRows([]);

                    $(tableRef.current).DataTable().destroy();
                    fetchCustomerStock();

                    Swal.fire(
                        'Deleted!',
                        'Selected records have been deleted.',
                        'success'
                    );

                } catch (error) {

                    console.error(error);

                    Swal.fire(
                        'Error!',
                        'There was a problem deleting records.',
                        'error'
                    );
                }
            }
        });
    };
    const HelpLink = localStorage.getItem('HelpLink');
    const handleCheckboxChange = (id) => {
    setSelectedRows((prev) =>
        prev.includes(id)
            ? prev.filter((rowId) => rowId !== id)
            : [...prev, id]
    );
};
    return (
        <div>
            <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                <div className="col-sm-3">
                    <button className={`btn btn-primary btn-sm ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} onClick={handleCreateCustomerStockClick}>
                        <i className="icofont-plus" aria-hidden="true"> Add/Edit</i>
                    </button>
                </div>
                <div className="col-sm-9" style={{ "textAlign": "right" }}>
                    <button style={{background:"#cb2a2a",color:"#ffffff"}}
                        className={`btn btn-sm ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`}
                        onClick={handleMultipleDelete}
                    >Delete</button>
                </div>
            </div>
            <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                <div className="col-sm-12">
                    <div>
                        <table className="table m-0 table-hover" ref={tableRef}>
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Stock Code</th>
                                    <th>Stock Name</th>
                                    <th>Sales Price</th>
                                    <th>Sepcial Price</th>
                                   
                                </tr>
                            </thead>
                            <tbody>
                                {CustomerStockList.map((stock) => (
                                    <tr key={stock.ID} onClick={() => handleEditClick(stock)} style={{ cursor: 'pointer' }}>
                                        <td
                                            onClick={(e) => e.stopPropagation()}
                                        >
                                            <input
                                                type="checkbox"
                                                checked={selectedRows.includes(stock.ID)}
                                                onChange={() => handleCheckboxChange(stock.ID)}
                                            />
                                        </td>
                                        <td>{stock.vc_StockCode}</td>
                                        <td>{stock.vc_StockName}</td>
                                        <td>{stock.mon_SalesPrice}</td>
                                        <td>{stock.SpecialPrice}</td>
                                        
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            {isModalOpen && (
                <PartSelectionModal
                    show={isModalOpen}
                    onClose={() => setIsModalOpen(false)}
                    parts={partList}
                    onSelectPart={handlePartSelect}
                    ClientCompanyID={CustomerID}
                />
            )}
        </div>
    );
}

export default CustomerDocumentPage;
